import type { Theme } from '@mui/material';

export type PillVariant =
  | 'primary'
  | 'secondary'
  | 'violet'
  | 'lightViolet'
  | 'lightPrimary'
  | 'comparisonPrimary'
  | 'comparisonSecondary';

export const pillBackgroundColor = (theme: Theme, colorName: PillVariant) =>
  ({
    primary: theme.colors.secondary[500],
    secondary: theme.colors.neutral[800],
    violet: theme.colors.violet[500],
    lightViolet: theme.colors.violet[200],
    lightPrimary: theme.colors.secondary[300],
    comparisonPrimary: theme.colors.comparison[700],
    comparisonSecondary: theme.colors.comparison[100],
  })[colorName];

export const pillColor = (theme: Theme, colorName: PillVariant) =>
  ({
    primary: theme.colors.secondary[800],
    secondary: theme.colors.white,
    violet: theme.colors.white,
    lightViolet: theme.colors.violet[800],
    lightPrimary: theme.colors.secondary[800],
    comparisonPrimary: theme.colors.comparison[50],
    comparisonSecondary: theme.colors.comparison[600],
  })[colorName];
